import { Button, Empty, Skeleton } from "antd"
import { LayoutGrid } from "lucide-react"
import { Link } from "react-router-dom"
import { useTheme } from "../../app/providers/theme-provider.js"
import { DashboardCanvas } from "../../features/dashboards/components/dashboard-canvas.js"
import { useHomeDashboard } from "../../features/dashboards/use-dashboards.js"
import { PageHeader } from "../../shared/components/page-header.js"

export function DashboardHomePage() {
  const { mode } = useTheme()
  const { data, isLoading } = useHomeDashboard()
  const dashboard = data?.dashboard ?? null

  if (isLoading) {
    return (
      <>
        <PageHeader title="Home" />
        <Skeleton active paragraph={{ rows: 8 }} />
      </>
    )
  }

  if (!dashboard) {
    return (
      <>
        <PageHeader title="Home" />
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <span style={{ fontSize: 13, color: "var(--csbi-ink-secondary)" }}>
              No home dashboard yet — open one of your dashboards and choose <b>Set as home</b>.
            </span>
          }
        >
          <Link to="/dashboards">
            <Button icon={<LayoutGrid size={14} />}>My dashboards</Button>
          </Link>
        </Empty>
      </>
    )
  }

  return (
    <>
      <PageHeader
        title={dashboard.name}
        {...(dashboard.description ? { description: dashboard.description } : {})}
        extra={
          <Link to={`/dashboards/${encodeURIComponent(dashboard.slug)}`}>
            <Button size="small">Open</Button>
          </Link>
        }
      />
      <DashboardCanvas dashboard={dashboard} tiles={dashboard.tiles} mode={mode} />
    </>
  )
}
